import { render } from "./SchedulerPage.vue?vue&type=template&id=2664d4bf&scoped=true"
import script from "./SchedulerPage.vue?vue&type=script&lang=js"
export * from "./SchedulerPage.vue?vue&type=script&lang=js"

import "./SchedulerPage.vue?vue&type=style&index=0&id=2664d4bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2664d4bf"]])

export default __exports__